import { render, staticRenderFns } from "./tagSelection.vue?vue&type=template&id=0e0c8f92&scoped=true"
import script from "./tagSelection.vue?vue&type=script&lang=js"
export * from "./tagSelection.vue?vue&type=script&lang=js"
import style0 from "./tagSelection.vue?vue&type=style&index=0&id=0e0c8f92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0c8f92",
  null
  
)

export default component.exports